import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

export const CarouselSwiper = styled(Swiper)`
	/* .swiper {} */
	width: 100%;
	height: 100%;
	padding: 0 1rem !important;
	overflow: visible !important;
`;

export const CarouselSwiperSlide = styled(SwiperSlide)`
	/* .swiper-slide {} */
	width: 75% !important;

	&.swiper-more-results {
		position: relative;
		width: 140px !important;
		margin-right: 0 !important;
	}

	a {
		text-decoration: none;
	}

	/* ion-card-header {
      p {
          color: var(--ion-color-light-shade);
          text-transform: uppercase;
          font-size: 12px;
      }
  } */
`;

export const CardTitleContainer = styled.div`
	position: relative;
	padding: 1rem;
	h3 {
		margin: 0;
		color: #fff;
		margin-bottom: 5px;
		margin-top: 10px;
	}
	p {
		margin: 0;
		font-size: 12px;
		//text-transform: uppercase;
		color: var(--ion-color-light-shade);
	}
	svg {
		width: 1.5rem;
		height: 1.5rem;
		margin-right: 0.25rem;
		path {
			fill: #fff;
		}
	}
`;

export const CarouselContainer = styled.section`
	padding: 0 0 1rem;

	&:first-of-type {
		header {
			padding-top: 3rem;
			border-top: unset;
		}
	}

	/* background-color: #B7B78A; */
`;

export const CarouselHeader = styled.header`
	margin-top: 1.5rem;
	margin-bottom: 2.5rem;
	padding: 1rem 1rem 0;

	display: flex;
	justify-content: space-between;
	align-items: end;
	h2 {
		margin: 0;
	}
	/* border-top: 1px solid var(--bg-200); */

	ion-icon {
		font-size: 2.2rem;
		fill: #606c38;
	}
`;

export const CarouselMeta = styled.p`
	margin: 0;
`;

export const ProgressBar = styled.div`
	width: calc(100% - 64px);
	height: 5px;
	margin: 20px 32px;
	padding: 0 32px;
	background-color: #afb081;
	border-radius: 10px;
	position: relative;
	overflow: hidden;
`;

interface ProgressProps {
	$progress: string;
}

export const ProgressInner = styled.div`
	width: ${(props: ProgressProps) => {
		return props.$progress;
	}};
	background: #606c38;
	height: 5px;
	position: absolute;
	top: 0;
	left: 0;
	border-radius: 50px;
	transition: width 0.2s ease-out;
`;

export const MoreResultsCard = styled.div`
	min-height: 248px;
	margin: 53px 0;
	border-radius: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 8px;
	background: #afb081;

	ion-icon {
		font-size: 80px;
		fill: #606c38;
	}
`;
